@if (entry?.base?.display) {
  <div>
    <!-- Show email form if the app is not submitted and the user has not confirmed their email -->
    @if (!entry.custom.isAppSubmitted && !isConfirmed) {
      @if (reviewOnly) {
        <em>You can resend the email here. <span>This is <strong>not</strong> required to submit the application.</span></em>
      }
      <form [formGroup]="emailForm" (submit)="sendEmail()">
        <mat-form-field appearance="outline">
          <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
          <input matInput formControlName="email" placeholder="example@abc.com" />
          @if (emailForm.controls.email.errors?.required) {
            <mat-error>Required {{reviewOnly ? 'to resend email.' : ''}}</mat-error>
          }
          @if (emailForm.controls.email.errors?.email) {
            <mat-error>Email format required: XXXX&#64;XXXX.XXXX</mat-error>
          }
        </mat-form-field>
        @if (!isLoading) {
          <button
            mat-raised-button
            type='submit'
            class="primary-btn"
            color='primary'
            (click)="sendEmail()"
          [disabled]="!emailForm.valid">Send Email</button>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
      </form>
      @if (!isLoading && formControl?.touched && formControl?.errors?.required) {
        <div class='component-error'>
          <mat-error>You must send the document email to the applicant before proceeding.</mat-error>
        </div>
      }
    }
    <!-- Show last sent message and status updates if the email has been sent and not confirmed -->
    @if (formControl?.value?.referralId && !isConfirmed) {
      <div class='component-status'>
        <span class='material-symbols-outlined success-icon'>check_circle</span>
        <em>The document was last emailed to {{formControl.value.email}}</em>
      </div>
      <div class='component-status'>
        <br/>
        @if (!isAwaitingStatus) {
          <span class='material-symbols-outlined warning-icon'>warning</span>
          <em>Awaiting customer acknowledgment. </em>
          <button mat-raised-button type="button" (click)="updateEmailStatus(formControl.value.referralId)">Refresh Status</button>
        }
        @if (isAwaitingStatus) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
        @if (statusErrorMsg) {
          <div><mat-error>{{statusErrorMsg}}</mat-error></div>
        }
      </div>
    }
    <!-- Only show the confirmation message when the email has been confirmed by the applicant -->
    @if (isConfirmed) {
      <div class='component-status'>
        <span class='material-symbols-outlined success-icon'>check_circle</span>
        <strong>The applicant has confirmed receiving the document in their email <em>{{formControl.value.email}}</em>.</strong>
      </div>
    }
  </div>
}